import { BaseExportFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { socialExport } from '@mi-front/api-clients';
import { useSocialExportGetTikTokCreatorInfo } from '@mi-front/api-v2';
import { QueryView } from '@mi-front/ui';
import { TikTokPublishFormContent } from './components/TikTokPublishFormContent';

type TikTokPublishFormProps = BaseExportFormProps<
  socialExport.TiktokPublishDto,
  socialExport.TiktokSettingsDto
>;

/**
 * TikTok publish form gated on creator info. Shows loading/error until creator info is loaded,
 * then renders the form with privacy and interaction options driven by creator info (TikTok guidelines).
 */
export function TikTokPublishForm({
  source,
  onUpload,
  defaultSettings,
  videoUrl,
  connectionId,
  actions,
}: TikTokPublishFormProps) {
  const creatorInfoQuery = useSocialExportGetTikTokCreatorInfo(connectionId, {
    query: { enabled: !!connectionId },
  });

  return (
    <QueryView query={creatorInfoQuery} inline>
      {(creatorInfo) => (
        <TikTokPublishFormContent
          source={source}
          onUpload={onUpload}
          defaultSettings={defaultSettings}
          videoUrl={videoUrl}
          connectionId={connectionId}
          actions={actions}
          creatorInfo={creatorInfo}
        />
      )}
    </QueryView>
  );
}
